import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { customerApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("mrshu_customer_token");
    if (!token) {
      setCustomer(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await customerApi.get("/auth/me");
      setCustomer(data);
    } catch {
      localStorage.removeItem("mrshu_customer_token");
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginSuccess = (token, cust) => {
    localStorage.setItem("mrshu_customer_token", token);
    setCustomer(cust);
  };

  const logout = () => {
    localStorage.removeItem("mrshu_customer_token");
    setCustomer(null);
  };

  return (
    <AuthContext.Provider value={{ customer, loading, loginSuccess, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
